import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-151da104")
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增 ")
_popScopeId()

import { PlusOutlined } from '@ant-design/icons-vue'
import { computed, ref, toRaw } from 'vue'
import SongUploadModal from './SongUploadModal.vue'


export default {
  props: {
  list: {
    type: Array,
    default: () => { return [] }
  },
  formIsEdit: {
    type: Boolean,
    default: () => { return false }
  },
  aliasConfig: {
    type: Object,
    default: () => {
      return {
        url: 'file_url',
        name: 'file_name',
        md5: 'file_md5',
        size: 'file_size'
      }
    }
  }
},
  emits: ['updateList'],
  setup(__props, { emit }) {

const props = __props




const listComputed = computed(() => props.list)
const formIsEditComputed = computed(() => props.formIsEdit)

const current = ref({})
const visible = ref(false)
const isEdit = ref(false)

const labelCol = { span: 5 }
const wrapperCol = { span: 17 }
const currentIndex = ref(-1)

const handleRemoveItem = item => {
  const list = ref(toRaw(listComputed.value))
  const index = list.value.indexOf(item)
  if (index !== -1) {
    list.value.splice(index, 1)
  }
  emit('updateList', list)
}

const handleEditItem = (item, index) => {
  visible.value = true
  current.value = item
  currentIndex.value = index
  isEdit.value = true
}

const handleAddConfig = () => {
  isEdit.value = false
  current.value = {}
  visible.value = true
  currentIndex.value = -1
}

const handleModalCancel = () => {
  current.value = {}
  visible.value = false
  currentIndex.value = -1
}

const handleModalOk = info => {
  const list = ref(toRaw(listComputed.value))
  list.value.push(info)
  emit('updateList', list.value)
}

const handleModalEditOk = info => {
  const list = ref(toRaw(listComputed.value))
  list.value[currentIndex.value] = info
  emit('updateList', list.value)
}


return (_ctx, _cache) => {
  const _component_a_space = _resolveComponent("a-space")
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_descriptions = _resolveComponent("a-descriptions")
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listComputed), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "card_body"
      }, [
        _createVNode(_component_a_descriptions, {
          title: `配置${index + 1}`,
          bordered: "",
          column: 6
        }, {
          extra: _withCtx(() => [
            (_unref(formIsEditComputed))
              ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: () => handleRemoveItem(item)
                    }, "移除", 8, _hoisted_1),
                    _createElementVNode("a", {
                      onClick: () => handleEditItem(item, index)
                    }, "编辑", 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, {
              label: "歌曲名",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item[props.aliasConfig.name]), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_descriptions_item, {
              label: "歌曲MD5",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item[props.aliasConfig.md5]), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_descriptions_item, {
              label: "歌曲文件地址",
              span: 6
            }, {
              default: _withCtx(() => [
                (item[props.aliasConfig.url].length > 90)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      title: item[props.aliasConfig.url]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item[props.aliasConfig.url].slice(0, 90)) + "...", 1)
                      ]),
                      _: 2
                    }, 1032, ["title"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item[props.aliasConfig.url]), 1))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["title"])
      ]))
    }), 128)),
    (_unref(formIsEditComputed))
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "add-btn",
          onClick: handleAddConfig
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PlusOutlined)),
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (visible.value)
      ? (_openBlock(), _createBlock(SongUploadModal, {
          key: 1,
          visible: visible.value,
          isEdit: isEdit.value,
          value: current.value,
          onCancel: handleModalCancel,
          onOnOk: handleModalOk,
          onOnEditOk: handleModalEditOk,
          aliasConfig: props.aliasConfig
        }, null, 8, ["visible", "isEdit", "value", "aliasConfig"]))
      : _createCommentVNode("", true)
  ]))
}
}

}